"use client"

import { usePathname } from "next/navigation"

import { navActiveUnderlineClassName } from "@/components/ui/nav-icon"
import {
  HEADER_NAV_ORDER,
  isNavItemActive,
  NAV_ITEMS,
  navIcons,
  navTexts,
  NavLink
} from "@/features/navigation"

export function Navigation() {
  const pathname = usePathname() ?? ""

  return (
    <nav
      className="hidden h-full min-w-0 flex-1 self-stretch overflow-visible xl:flex"
      aria-label={navTexts.ariaLabel}
    >
      <ul className="flex h-full items-center overflow-visible">
        {HEADER_NAV_ORDER.map((id) => {
          const item = NAV_ITEMS[id]
          const isActive =
            !item.comingSoon && isNavItemActive(pathname, item.href)

          return (
            <li
              key={id}
              className="relative flex h-full items-center overflow-visible pl-[15px] pr-5"
            >
              <NavLink
                href={item.href}
                label={navTexts.items[id]}
                icon={navIcons[id]}
                isActive={isActive}
                comingSoon={item.comingSoon}
                className="gap-2.5"
                labelClassName="text-sm"
              />
              {isActive ? (
                <span aria-hidden className={navActiveUnderlineClassName} />
              ) : null}
            </li>
          )
        })}
      </ul>
    </nav>
  )
}
